import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { SUGGESTED_SKILLS } from 'src/constants/suggestions';
import { User } from 'src/api';
import { user as userActions } from 'src/actions';
import createLogger from 'src/utils/logger';
import { SaveBtn, DeleteableInput, AutoSuggestInput } from 'src/components/Common';

class UserSkills extends Component {
  constructor() {
    super();
    this.logger = createLogger('UserSkills');
    this.state = {
      inEditMode: false,
      skills: [],
    };
  }

  componentDidMount() {
    this.setState({ skills: this.getPropsUserRoles() });
  }

  toggleEdit = () => {
    this.setState((state) => {
      return {
        skills: this.getPropsUserRoles(),
        inEditMode: !state.inEditMode,
      }
    });
  }

  getPropsUserRoles = () => {
    return [...this.props.skills];
  }

  getSkillsSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    return !inputValue.length ? [] : SUGGESTED_SKILLS.filter((skill) => skill.toLowerCase().indexOf(inputValue) !== -1);
  }

  onSkillAdd = (skill) => {
    this.logger.info('onSkillAdd()', skill);
    return new Promise((res, rej) => {
      if (this.state.skills.indexOf(skill) === -1) {
        this.setState({
          skills: [...this.state.skills, skill],
        })
        res();
      } else {
        rej('Такое умение уже добавлено.');
      }
    })
  }

  onSkillDeletion = (skill) => {
    this.logger.info('onSkillDeletion()', skill);
    this.setState((state) => {
      const skillIndex = state.skills.indexOf(skill);
      if (skillIndex > -1) {
        const skills = [...state.skills];
        skills.splice(skillIndex, 1);
        return { skills };
      }
      return state;
    })
  }

  saveUpdatedSkills = () => {
    this.logger.info('saveUpdatedSkills()', this.state.skills);
    User.updateUser.updateSkillsAndRoles({ roles: this.props.roles, skills: this.state.skills })
      .then((res) => {
        this.props.updateSkillsAndRoles({ skills: res.data.skills, roles: res.data.roles });
        toast.success('Роли успешно обновлены.');
        this.toggleEdit()
      })
      .catch((err) => {
        toast.error('Что-то пошло не так :(');
        this.logger.error('NOT UPDATED ROLES:', err.response);
      });
  }

  render() {
    return (
      <div className={`left-bar__block roles-bar ${this.state.inEditMode ? 'editing' : ''}`}>
      {
        this.state.inEditMode ? (
          <div className="roles-bar--edit">
            <div className="left-bar__title">Навыки</div>
            <div className="edit--block">
              {this.state.skills.map((skill) => {
                return (
                  <DeleteableInput key={skill} inputName={skill} value={skill} isEditable={false} onDelete={this.onSkillDeletion} />
                );
              })}
            </div>
            <div className="edit-block">
              <AutoSuggestInput
                getSuggestions={this.getSkillsSuggestions}
                addEntity={this.onSkillAdd} />
            </div>
            <div className="edit-block">
              <SaveBtn saveText="Сохранить" cancelText="Отменить" onSave={this.saveUpdatedSkills} onCancel={this.toggleEdit} />
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className="left-bar__block-header">
              <div className="left-bar__edit" onClick={this.toggleEdit}>
                {this.props.editSvg}
              </div>
              <div className="left-bar__title">Навыки</div>
            </div>
            <div className="left-bar__block-content">
              {this.props.skills.map((el, i) => <p className='left-bar__text' key={i}>{el}</p>)}
            </div>
          </React.Fragment>
        )
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    skills: state.user.skills,
    roles: state.user.roles,
  }  
}

UserSkills.propTypes = {
  skills: PropTypes.array.isRequired,
  roles: PropTypes.array.isRequired,
  updateSkillsAndRoles: PropTypes.func.isRequired,
  editSvg: PropTypes.element.isRequired,
}

export default connect(mapStateToProps, {
  updateSkillsAndRoles: userActions.updateSkillsAndRoles,
})(UserSkills);



// WEBPACK FOOTER //
// ./src/components/Account/LeftBar/UserSkills/index.js